import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuItem } from '@angular/material/menu';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-mark-as-not-span-button',
  templateUrl: './mark-as-not-span-button.component.html',
  styleUrls: ['./mark-as-not-span-button.component.scss'],
  imports: [TranslateModule, MatMenuItem, MatIconButton, MatTooltip, MatIcon],
})
export class MarkAsNotSpanButtonComponent {
  @Input() isMenu = false;

  constructor() {}
}
